export default {
  el: {
    colorpicker: {
      confirm: 'Aceptar',
      clear: 'Limpar'
    },
    datepicker: {
      now: 'Agora',
      today: 'Hoxe',
      cancel: 'Cancelar',
      clear: 'Limpar',
      confirm: 'Aceptar',
      selectDate: 'Seleccionar data',
      selectTime: 'Seleccionar hora',
      startDate: 'Data inicio',
      startTime: 'Hora inicio',
      endDate: 'Data fin',
      endTime: 'Hora fin',
      prevYear: 'Ano anterior',
      nextYear: 'Próximo ano',
      prevMonth: 'Mes anterior',
      nextMonth: 'Próximo mes',
      year: '',
      month1: 'Xaneiro',
      month2: 'Febreiro',
      month3: 'Marzo',
      month4: 'Abril',
      month5: 'Maio',
      month6: 'Xuño',
      month7: 'Xullo',
      month8: 'Agosto',
      month9: 'Setembro',
      month10: 'Outubro',
      month11: 'Novembro',
      month12: 'Decembro',
      // week: 'semana',
      weeks: {
        sun: 'Dg',
        mon: 'Lu',
        tue: 'Ma',
        wed: 'Me',
        thu: 'Xo',
        fri: 'Ve',
        sat: 'Sá'
      },
      months: {
        jan: 'Xan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Abr',
        may: 'Mai',
        jun: 'Xuñ',
        jul: 'Xul',
        aug: 'Ago',
        sep: 'Set',
        oct: 'Out',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Cargando',
      noMatch: 'Non hai datos que coincidan',
      noData: 'Sen datos',
      placeholder: 'Seleccionar'
    },
    cascader: {
      noMatch: 'Non hai datos que coincidan',
      loading: 'Cargando',
      placeholder: 'Seleccionar',
      noData: 'Sen datos'
    },
    pagination: {
      goto: 'Ir a',
      pagesize: '/páxina',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      confirm: 'Aceptar',
      cancel: 'Cancelar',
      error: 'Entrada non válida'
    },
    upload: {
      deleteTip: 'Prema Eliminar para retirar',
      delete: 'Eliminar',
      preview: 'Vista previa',
      continue: 'Continuar'
    },
    table: {
      emptyText: 'Sen datos',
      confirmFilter: 'Confirmar',
      resetFilter: 'Reiniciar',
      clearFilter: 'Limpar',
      sumText: 'Suma'
    },
    tree: {
      emptyText: 'Sen datos'
    },
    transfer: {
      noMatch: 'Non hai datos que coincidan',
      noData: 'Sen datos',
      titles: ['Lista 1', 'Lista 2'],
      filterPlaceholder: 'Introducir palabra clave',
      noCheckedFormat: '{total} elementos',
      hasCheckedFormat: '{checked}/{total} seleccionados'
    },
    image: {
      error: 'FALLOU'
    },
    pageHeader: {
      title: 'Volver'
    },
    popconfirm: {
      confirmButtonText: 'Si',
      cancelButtonText: 'Non'
    },
    empty: {
      description: 'Sen datos'
    }
  }
}
